import React from "react";
export default function ButtonIcon({ className, handleClick, icon, disabled, shadow }) {
	return (
		<button className={`${className} btn-shadow-${shadow}`} onClick={handleClick} disabled={disabled}>
			{icon}
		</button>
	);
}